<template>
  <div class="text-white PageHeader">
    <div class="container">
      <div class="PageHeader__breadcrumb">
        <slot name="breadcrumb"></slot>
      </div>

      <div class="PageHeader__title">
        <slot name="title"></slot>
      </div>

      <slot></slot>
    </div>
  </div>
</template>

<style lang="less" type="text/less">
@import "~dashboard-less/variables";
@import "~dashboard-less/spark/components/Tabs";
@import "~dashboard-less/spark/utilities";

.PageHeader {
  .Tabs(white);
  .container {
    padding-left: 15px;
    padding-right: 15px;
  }

  .PageHeader__breadcrumb ol {
    .truncate;
    list-style: none;

    li:not(:first-child):before {
      display: inline-block;
      font: normal normal normal 14px/1 FontAwesome;
      content: "\f178";
      color: #ccc;
      padding: 0 5px;
    }

    li {
      display: inline-block;
    }

    li > a {
      color: white;
      font-style: italic;
    }
  }

  .PageHeader__title {
    margin: 20px 0;
    text-align: center;
  }
  .PageHeader__title * {
    color: white;
    font-weight: 700;
    font-style: italic;

    small {
      margin-left: 10px;
    }

    h1:not(.apply-job-title) {
      font-size: 30px;
    }
  }
  @media (max-width: @screen-xs-max) {
    .PageHeader__title {
      margin: 10px 0;

      h1:not(.apply-job-title) {
        font-size: 23px;
      }
    }

    .Tabs {
      display: flex;
      // margin: 0 -15px;
      // border-top: 1px solid lighten(@brand-primary, 5%);

      li {
        flex: 1;
        text-align: center;

        & > a {
          margin: 0 !important;
        }
      }
    }
  }
}
body.--agent-mobile-app {
  .PageHeader {
    position: sticky;
    top: 0;
    z-index: 1000;
  }
  .PageHeader__title,
  .PageHeader__breadcrumb {
    display: none;
  }
}
</style>

<script type="text/babel">
export default {
  name: "PageHeader",
  props: [],
};
</script>
